export default {
  outbound: 'Ida',
  inbound: 'Regreso',
  hide: 'Ocultar',
  details: 'Detalles',
}
